import { cn } from "@/lib/utils";

interface VideoClipProps {
    src: string;
    alt: string;
    className?: string;
}

export function VideoClip({ src, alt, className }: VideoClipProps) {
    return (
        <video
            autoPlay
            loop
            muted
            playsInline
            preload="none"
            aria-label={alt}
            className={cn("w-full h-auto block", className)}
        >
            <source src={src} type="video/mp4" />
        </video>
    );
}
